import type { PermissionSelector } from "@/hooks/usePermission";

export const canListAutomatedSurveys: PermissionSelector = (p) => p.isSuperAdmin;

export const canManageAutomatedSurveys: PermissionSelector = (p) => p.isSuperAdmin;
